import { from, fromEventPattern } from 'rxjs';
import { tap, shareReplay, mergeWith, map, filter, switchMap, startWith, scan, timeout, catchError, take } from 'rxjs/operators';
import lodashGet from 'lodash/get';
import has from 'lodash/has';
const lodashHas = has;
export class TeamMuteStream {
    constructor() {
        this.sdk = null;
        this.subject = null;
    }
    init(sdk) {
        this.sdk = sdk;
        this.subject = this._initTeamMutelist().pipe(mergeWith(this._onupdateteam()), scan((total, current) => {
            const _mutelist = new Set([...(Array.isArray(current) ? current : []), ...total]);
            if (lodashGet(current, 'muteTeam', undefined) === true) {
                _mutelist.add(current.teamId);
            }
            else if (lodashGet(current, 'muteTeam', undefined) === false) {
                _mutelist.delete(current.teamId);
            }
            return [..._mutelist];
        }, []), catchError(() => from(Promise.resolve([]))), tap(result => {
            console.log('[im.teammute]result:', result);
        }), shareReplay(1));
        this.subject.subscribe(args => {
            console.log('[im.teammute]subscribe', args);
        });
    }
    _initTeamMutelist() {
        const onconnect = (handler) => {
            this.sdk.subscrible('onconnect', handler);
        };
        const offconnect = (handler) => {
            this.sdk.subscrible('onconnect', handler);
        };
        const onteams = (handler) => {
            this.sdk.subscrible('onteams', handler);
        };
        const offteams = (handler) => {
            this.sdk.unSubcrible('onteams', handler);
        };
        const $event = fromEventPattern(onconnect, offconnect).pipe(switchMap(() => {
            const $onteams = fromEventPattern(onteams, offteams);
            return $onteams.pipe(timeout({ first: 30 * 1000 }));
        }), take(1));
        return $event.pipe(catchError(() => {
            const request = this.sdk.excute('getTeams', {});
            return from(request);
        }), map(list => list.filter(item => item.valid && item.validToCurrentUser).map(item => item.teamId)), filter(list => list.length > 0), switchMap(teamIds => {
            var _a;
            const $promise = (_a = this.sdk) === null || _a === void 0 ? void 0 : _a.excute('notifyForNewTeamMsg', {
                teamIds,
            });
            return from($promise);
        }), map(result => Object.keys((result || {})).filter(key => !!Number(result[key]))), catchError(() => from(Promise.resolve([]))), startWith([]));
    }
    _onupdateteam() {
        const onupdateteammember = (handler) => {
            this.sdk.subscrible('onupdateteammember', handler);
        };
        const offupdateteammember = (handler) => {
            this.sdk.unSubcrible('onupdateteammember', handler);
        };
        const $event = fromEventPattern(onupdateteammember, offupdateteammember);
        return $event.pipe(filter(team => lodashHas(team, 'muteTeam')), tap(args => {
            console.log('[im.teammute]updateteaminfo', args);
        }), startWith({}));
    }
    getSubject() {
        return this.subject;
    }
}
